<p class="legal" *ngIf="legalContent">{{ legalContent }}</p>
